import { render, staticRenderFns } from "./FilterSwitch.vue?vue&type=template&id=78be982f&scoped=true"
import script from "./FilterSwitch.vue?vue&type=script&lang=js"
export * from "./FilterSwitch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78be982f",
  null
  
)

export default component.exports